var _excluded = ["disabled", "href"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import classesPropType from "@xo-union/classes-prop-type";
import DisplayElement from "../DisplayElement/index.js";
var hasMouseEvent = function hasMouseEvent(props) {
  return props.onMouseDown || props.onMouseUp || props.onClick;
};
var DisplayLink = function DisplayLink(_ref) {
  var disabled = _ref.disabled,
    href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded);
  var linkSpecificProps = disabled ? {} : {
    href: href
  };
  if (hasMouseEvent(props) && !href) {
    process.env.NODE_ENV !== 'production' ? console.warn('`DisplayLink` was rendered with no href and a mouse event handler. This more than likely means you should render a `DisplayButton`') : void 0;
  }
  return /*#__PURE__*/React.createElement(DisplayElement, _extends({
    disabled: disabled || !href
  }, linkSpecificProps, props, {
    htmlDisabled: false
  }));
};
DisplayLink.defaultProps = {
  as: 'a',
  color: 'secondary',
  size: 'lg'
};
process.env.NODE_ENV !== "production" ? DisplayLink.propTypes = {
  /**
   * href to visit on click
   */
  href: PropTypes.string,
  /**
   * Disable link
   */
  disabled: PropTypes.bool,
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  /**
   * The link's content
   */
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType(['display-link', 'icon', 'tappable-area']),
  /**
   * Class name to append
   */
  className: PropTypes.string,
  /**
   * Color class
   * */
  color: PropTypes.oneOf(['primary', 'primary-alternative', 'secondary', 'tertiary']),
  /**
   * Icon to place next to CTA text
   */
  iconName: PropTypes.string,
  /**
   * Determines whether the link text will be on the left or right side of the icon
   */
  labelDirection: PropTypes.oneOf(['left', 'right']),
  /**
   * Size class
   * */
  size: PropTypes.oneOf(['md', 'lg'])
} : void 0;
export default DisplayLink;